import React, { useState, useEffect } from 'react';

// Import configurations
import { CONCEPT_DISPLAY, ANIMATIONS } from '../../config/animations';

const AnimatedConceptDisplay = ({ selectedConcept }) => {
    const [currentConcept, setCurrentConcept] = useState(selectedConcept);
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        if (selectedConcept !== currentConcept && !isAnimating) {
            setIsAnimating(true);

            setTimeout(() => {
                setCurrentConcept(selectedConcept);
                setIsAnimating(false);
            }, CONCEPT_DISPLAY.ANIMATION_SPEED);
        }
    }, [selectedConcept, currentConcept, isAnimating]);

    const getAnimationClass = () => {
        if (!isAnimating) return '';
        return ANIMATIONS.SLIDE.LEFT.OUT;
    };

    const getNextAnimationClass = () => {
        return ANIMATIONS.SLIDE.LEFT.IN;
    };

    return (
        <div className="relative w-full h-full overflow-hidden">
            {/* Current Image */}
            <div className={`absolute inset-0 w-full h-full ${getAnimationClass()}`}>
                <img
                    src={`${CONCEPT_DISPLAY.PREVIEW_PATH}/${currentConcept}.gif`}
                    alt={`Concept ${currentConcept}`}
                    className="w-full h-full object-contain"
                />
            </div>

            {/* Next Image */}
            {isAnimating && (
                <div className={`absolute inset-0 w-full h-full ${getNextAnimationClass()}`}>
                    <img
                        src={`${CONCEPT_DISPLAY.PREVIEW_PATH}/${selectedConcept}.gif`}
                        alt={`Concept ${selectedConcept}`}
                        className="w-full h-full object-contain"
                    />
                </div>
            )}
        </div>
    );
};

export default AnimatedConceptDisplay;